module.exports = __webpack_public_path__ + "static/media/overflow-white.32aaf386.svg";